import { belgium, checkVAT } from '@accountable/jsvat';
import isNil from 'lodash/isNil';

const BUSINESS_NUMBER_SEPARATORS = /[\s./-]/g;
const BELGIAN_COUNTRY_CODE = 'BE';
const LEADING_BELGIAN_COUNTRY_CODE = /^BE/i;
const BELGIAN_ENTERPRISE_NUMBER_GROUPS = /^(\d{4})(\d{3})(\d{3})$/;

export const removeBusinessNumberSeparators = (businessNumber: string): string =>
  businessNumber.replace(BUSINESS_NUMBER_SEPARATORS, '');

/**
 * The ten digits of a Belgian enterprise number (KBO/BCE), whatever the separators or `BE` prefix it was typed
 * with, or null when the business number is not a valid Belgian enterprise number.
 */
export const getBelgianEnterpriseNumber = (businessNumber: string): string | null => {
  const withoutCountryCode = removeBusinessNumberSeparators(businessNumber).replace(LEADING_BELGIAN_COUNTRY_CODE, '');
  const { isValid, value } = checkVAT(`${BELGIAN_COUNTRY_CODE}${withoutCountryCode}`, [belgium]);
  return isValid && !isNil(value) ? value.slice(BELGIAN_COUNTRY_CODE.length) : null;
};

/**
 * Display form of a business number: a Belgian enterprise number in its official `0123.456.789` notation,
 * any other number as stored.
 */
export const formatBusinessNumber = (businessNumber: string): string => {
  const belgianEnterpriseNumber = getBelgianEnterpriseNumber(businessNumber);
  return isNil(belgianEnterpriseNumber)
    ? businessNumber
    : belgianEnterpriseNumber.replace(BELGIAN_ENTERPRISE_NUMBER_GROUPS, '$1.$2.$3');
};
